var __rest = this && this.__rest || function (s, e) {
  var t = {};
  for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0) t[p] = s[p];
  if (s != null && typeof Object.getOwnPropertySymbols === "function") for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
    if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i])) t[p[i]] = s[p[i]];
  }
  return t;
};
import * as React from 'react';
const SvgTrustShield = _a => {
  var _b, _c;
  var {
      size
    } = _a,
    props = __rest(_a, ["size"]);
  return React.createElement("svg", Object.assign({
    width: size !== null && size !== void 0 ? size : 24,
    height: size !== null && size !== void 0 ? size : 24,
    viewBox: "0 0 24 24",
    xmlns: "http://www.w3.org/2000/svg",
    role: props.role,
    "aria-hidden": (_b = props['aria-hidden']) !== null && _b !== void 0 ? _b : true
  }, props), React.createElement("path", {
    fillRule: "evenodd",
    d: "M12.492 1l.001.001.009.01.036.039.148.157a22.371 22.371 0 002.627 2.318C17.035 4.814 19.202 6 21.266 6a.75.75 0 01.75.75c0 6.425-2.58 10.552-5.188 13.064a16.795 16.795 0 01-3.57 2.626c-.488.267-.897.457-1.188.581a9.045 9.045 0 01-.44.175l-.027.01-.009.003h-.003v.001c-.001 0-.002 0-.242-.71-.268.7-.269.7-.27.7l-.004-.002-.008-.003-.025-.01a7.619 7.619 0 01-.396-.178c-.26-.127-.625-.318-1.06-.587a15.135 15.135 0 01-3.165-2.64C4.114 17.26 1.85 13.145 1.85 6.75A.75.75 0 012.6 6c2.063 0 4.23-1.186 5.954-2.476a22.377 22.377 0 002.627-2.317l.148-.157.036-.04.008-.009.002-.001a.75.75 0 011.117 0zM11.35 22.5l.24.71a.75.75 0 01-.508-.01l.268-.7zm.131-.858l-.112.047a10.305 10.305 0 01-.991-.545 13.639 13.639 0 01-2.85-2.377C5.544 16.6 3.518 13.05 3.36 7.459c2.296-.243 4.485-1.53 6.093-2.733a23.881 23.881 0 002.48-2.145 23.878 23.878 0 002.48 2.145c1.609 1.202 3.796 2.49 6.092 2.733-.18 5.56-2.461 9.101-4.717 11.274a15.3 15.3 0 01-3.248 2.391c-.442.241-.807.41-1.059.518zm4.482-11.444a.75.75 0 00-1.06-1.06l-4.137 4.136-1.803-1.803a.75.75 0 00-1.06 1.06l2.333 2.334a.75.75 0 001.06 0l4.667-4.667z",
    fill: (_c = props.color) !== null && _c !== void 0 ? _c : 'currentColor'
  }));
};
export default SvgTrustShield;